import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// api
import * as course_itemAPI from 'api/course_item';
import * as course_itemTypes from 'types/course_item';

// ----------------------------------------------------------------------

type course_item = {
  loading: boolean;
  isLoadingMore: boolean;
  courseList: { rows: any[]; total: number };
  courseFolder: { id: string; res_type: string } | null;
  filesBreadcrumbs: any;
  curPublish: any;
};

const initialState: course_item = {
  loading: false,
  isLoadingMore: false,
  courseList: { rows: [], total: -1 },
  courseFolder: null,
  filesBreadcrumbs: [],
  curPublish: {}
};

const slice = createSlice({
  name: 'course_item',
  initialState,
  reducers: {
    startLoading(state) {
      state.loading = true;
    },

    startLoadingMore(state) {
      state.isLoadingMore = true;
    },

    setCourseList(state, action) {
      state.loading = false;
      state.isLoadingMore = false;
      state.courseList = action.payload;
    },

    appendCourseList(state, action) {
      state.isLoadingMore = false;
      const existingRows = state.courseList.rows || [];
      const newRows = action.payload.rows || [];
      state.courseList = {
        rows: [...existingRows, ...newRows],
        total: action.payload.total
      };
    },

    setCourseFolder(state, action) {
      state.loading = false;
      state.courseFolder = action.payload;
    },
    setcurPublish(state, action) {
      state.loading = false;
      state.curPublish = action.payload;
    },
    addBreadcrumb: (state, action) => {
      // 直接追加，不做跳转
      state.filesBreadcrumbs.push(action.payload);
    },
    goToBreadcrumb: (state, action) => {
      // 截取到点击的面包屑
      const index = state.filesBreadcrumbs.findIndex((b: any) => b.id === action.payload);
      if (index !== -1) {
        state.filesBreadcrumbs = state.filesBreadcrumbs.slice(0, index + 1);
      }
    },
    clearBreadcrumbs: (state) => {
      state.filesBreadcrumbs = [];
    },
    clearCourseList: (state) => {
      state.courseList = { rows: [], total: -1 };
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
// Actions
export const {
  setCourseList,
  setCourseFolder,
  setcurPublish,
  addBreadcrumb,
  appendCourseList,
  goToBreadcrumb,
  clearBreadcrumbs,
  clearCourseList
} = slice.actions;

// action

// 获取学校资料库数量
export function get_list(params: course_itemTypes.get_list_params) {
  return async (dispatch: any, getState: any) => {
    const offset = Number(params?.offset || 0);
    const limit = Number(params?.limit || 20);
    const { callback, offset: _offset, limit: _limit, ...rest } = params;

    if (!offset) {
      dispatch(slice.actions.startLoading());
    } else {
      dispatch(slice.actions.startLoadingMore());
    }

    try {
      const response = await course_itemAPI.get_list({ ...rest, offset, limit });
      console.log(response);

      // 规范化响应格式
      let normalized = response;
      if (Array.isArray(response)) {
        normalized = { rows: response, total: response.length };
      } else if (!response.rows) {
        normalized = { rows: response, total: response.length };
      }

      if (offset > 0) {
        dispatch(slice.actions.appendCourseList(normalized));
      } else {
        dispatch(slice.actions.setCourseList(normalized));
      }

      if (callback) {
        callback(normalized?.total);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// 新增学校资料库
export function add_v2(params: course_itemTypes.add_v2_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, ...rest } = params;
    try {
      const response = await course_itemAPI.add_v2(rest);
      console.log(response);

      // dispatch(slice.actions.setFullClassList(response));

      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// 删除学习室内容
export function delete_item(params: course_itemTypes.delete_item_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, ...rest } = params;
    try {
      const response = await course_itemAPI.delete_item(rest);
      console.log(response);

      // dispatch(slice.actions.setFullClassList(response));

      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    }
  };
}

// 获取发布时间
export function get_course_item_publish(params: course_itemTypes.get_course_item_publish_params) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, finallyCallback, ...rest } = params;
    try {
      const response = await course_itemAPI.get_course_item_publish(rest);

      console.log(response);

      // if (response?.publish_time) {
      dispatch(slice.actions.setcurPublish(response));
      // }

      if (callback) {
        callback(response);
      }
    } catch (error) {
      // dispatch(slice.actions.hasError(error));
    } finally {
      if (finallyCallback) {
        finallyCallback();
      }
    }
  };
}

// 更新发布时间
export function update_course_item_publish(
  params: course_itemTypes.update_course_item_publish_params
) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, errorCallback, finallyCallback, ...rest } = params;
    try {
      const response = await course_itemAPI.update_course_item_publish(rest);
      console.log(response);

      // dispatch(slice.actions.setFullClassList(response));

      if (callback) {
        callback(response);
      }
    } catch (error) {
      if (errorCallback) {
        errorCallback();
      }
    } finally {
      if (finallyCallback) {
        finallyCallback();
      }
    }
  };
}

// 是否允许下载
export function update_course_item_download(
  params: course_itemTypes.update_course_item_download_params
) {
  return async () => {
    dispatch(slice.actions.startLoading());
    const { callback, errorCallback, finallyCallback, ...rest } = params;
    try {
      const response = await course_itemAPI.update_course_item_download(rest);
      console.log(response);

      // dispatch(slice.actions.setFullClassList(response));

      if (callback) {
        callback(response);
      }
    } catch (error) {
      if (errorCallback) {
        errorCallback();
      }
    } finally {
      if (finallyCallback) {
        finallyCallback();
      }
    }
  };
}
